import type { DemoScenarioResolved } from 'tio-data/demo/types';
import type { DemoProductConfig, DemoScenario } from 'tio-employee/demo/types';
import {
  IN_PROGRESS_TAS_FETCH_MATCHERS,
  IN_PROGRESS_TAS_MATCHERS,
} from 'tio-employee/demo/products/tas-fixtures';

/**
 * Builds the demo matchers + fixtures for the Tuition Assistance product, so
 * the store-routed TAS pages render demo data through their normal store calls.
 * Ships the in-progress scenario; other scenario ids fall through to the
 * real network until authored.
 */
export function buildTasDemo(
  config: Extract<DemoProductConfig, { kind: 'tas' }>,
  _scenario: DemoScenario
): DemoScenarioResolved {
  if (config.scenarioId === 'in-progress') {
    return {
      matchers: IN_PROGRESS_TAS_MATCHERS,
      seed: [],
      fetchMatchers: IN_PROGRESS_TAS_FETCH_MATCHERS,
    };
  }
  return { matchers: [], seed: [] };
}
